import { Award } from "./awards.model";

export const AWARDS_DATA: Award[] = [
  {
    year: 2025,
    name: "Nate Astrom",
    award: "Great Lakes All Region 1st Team"
  },
  {
    year: 2024,
    name: "Nate Astrom",
    award: "Great Lakes All Region 1st Team"
  },
  {
    year: 2024,
    name: "Kai Tang",
    award: "Great Lakes All Region Honorable Mention"
  },
  {
    year: 2023,
    name: "Kai Tang",
    award: "Great Lakes All Region 1st Team"
  },
  {
    year: 2023,
    name: "Dean Gottlieb",
    award: "Freshman of the Region Honorable Mention"
  },
  {
    year: 2022,
    name: "Eli Artemakis",
    award: "Great Lakes All Region 1st Team"
  },
  {
    year: 2021,
    name: "Eli Artemakis",
    award: "D-I Mens Rookie of the Year",
  },
  {
    year: 2019,
    name: "Joey Kennedy",
    award: "Great Lakes All Freshman Team",
  },
  {
    year: 2018,
    name: "Ben Sabourin",
    award: "All Region 2nd Team",
  },
  {
    year: 2018,
    name: "Reid Martin",
    award: "Great Lakes All Freshman Team",
  },
  {
    year: 2018,
    name: "Anthony Ruzzo",
    award: "Great Lakes All Freshman Team",
  },
  {
    year: 2017,
    name: "Drake Hill",
    award: "Great Lakes All Freshman Team",
  },
  {
    year: 2016,
    name: "Nick Prozorovsky",
    award: "All Region 1st Team",
  },
  {
    year: 2016,
    name: "Johnny Saniat",
    award: "All Region 1st Team",
  },
  {
    year: 2016,
    name: "Prayag Patel",
    award: "All Region 2nd Team",
  },
  {
    year: 2016,
    name: "Ben Sabourin",
    award: "Great Lakes FOTY",
  },
  {
    year: 2016,
    name: "Jacob Cuthbert",
    award: "Great Lakes All Freshman Team",
  },
  {
    year: 2015,
    name: "Matt Stupca",
    award: "Great Lakes COTY",
  },
  {
    year: 2015,
    name: "Nick Prozorovsky",
    award: "All Region 1st Team",
  },
  {
    year: 2015,
    name: "Matt West",
    award: "All Region 1st Team",
  },
  {
    year: 2015,
    name: "Kevin Lin",
    award: "Great Lakes FOTY",
  },
  {
    year: 2014,
    name: "Neal Phelps",
    award: "All Region 1st Team",
  },
  {
    year: 2014,
    name: "Nick Prozorovsky",
    award: "All Region 2nd Team",
  },
  {
    year: 2013,
    name: "Nathan Gibbons",
    award: "All Region 1st Team",
  },
  {
    year: 2013,
    name: "Neal Phelps",
    award: "All Region 1st Team",
  },
  {
    year: 2013,
    name: "Ryan Smith",
    award: "Great Lakes POTY",
  },
  {
    year: 2013,
    name: "Brad Bolliger",
    award: "All Region 2nd Team",
  },
  {
    year: 2013,
    name: "Nick Prozorovsky",
    award: "All Freshman",
  },
  {
    year: 2013,
    name: "Johnny Saniat",
    award: "All Freshman",
  },
  {
    year: 2013,
    name: "Derek Yan",
    award: "All Freshman",
  },
  {
    year: 2012,
    name: "Ryan Smith",
    award: "All Region 1st Team",
  },
  {
    year: 2012,
    name: "Dane Jorgensen",
    award: "All Region 2nd Team",
  },
  {
    year: 2011,
    name: "Ryan Smith",
    award: "All Region 1st Team",
  },
  {
    year: 2010,
    name: "Walden Nelson",
    award: "All Region 1st Team",
  },
  {
    year: 2010,
    name: "Brian Phelan",
    award: "All Region 1st Team",
  },
  {
    year: 2010,
    name: "Ryan Smith",
    award: "All Region 2nd Team",
  },
  {
    year: 2009,
    name: "Matt Stupca",
    award: "Great Lakes COTY",
  },
  {
    year: 2009,
    name: "Denis Agniel",
    award: "All Region 2nd Team",
  },
  {
    year: 2009,
    name: "Walden Nelson",
    award: "All Region 2nd Team",
  },
  {
    year: 2009,
    name: "Pavan Sarguru",
    award: "All Region 2nd Team",
  },
  {
    year: 2009,
    name: "Ryan Smith",
    award: "Great Lakes FOTY",
  },
  {
    year: 2008,
    name: "Joel Koehneman",
    award: "All Region 1st Team",
  },
  {
    year: 2008,
    name: "Pat Stephens",
    award: "All Region 1st Team",
  },
  {
    year: 2007,
    name: "Joel Koehneman",
    award: "All Region 1st Team",
  },
  {
    year: 2007,
    name: "Brian Korbesmeyer",
    award: "All Region 1st Team",
  },
  {
    year: 2006,
    name: "Brian Phelan",
    award: "Great Lakes FOTY",
  },
  {
    year: 2005,
    name: "Nick McDuffee",
    award: "All Region 1st Team",
  },
  {
    year: 2005,
    name: "Mike Clark",
    award: "All Region 1st Team",
  },
  {
    year: 2005,
    name: "David Abram",
    award: "Great Lakes FOTY",
  },
  {
    year: 2004,
    name: "Matt Welsh",
    award: "All Region 1st Team",
  },
  {
    year: 2004,
    name: "Nick McDuffee",
    award: "All Region 1st Team",
  },
  {
    year: 2004,
    name: "Pat Stephens",
    award: "Great Lakes FOTY",
  },
  {
    year: 2003,
    name: "Nate Bosscher",
    award: "All Region 1st Team",
  },
  {
    year: 2002,
    name: "Xi Xia",
    award: "All Region 1st Team",
  },
  {
    year: 2002,
    name: "Dane Olsen",
    award: "Great Lakes FOTY",
  },
];
